import { useMutation, useQueryClient } from 'react-query'
import axios from 'axios'
import cogoToast from 'cogo-toast'

interface CreateAlunno {
  annoScolastico: string
  sezioneId: number
  cognome: string
  nome?: string
  dataInizio?: string
}

const createAlunno = async (servizioId: number, alunno: CreateAlunno) => {
  const { data } = await axios.post(`/servizi/${servizioId}/aggiungi-alunno-fruizione/`, alunno)
  return data
}

const useCreateAlunno = () => {
  const queryClient = useQueryClient()
  return useMutation(
    ({ servizioId, alunno }: { servizioId: number; alunno: CreateAlunno }) => {
      return createAlunno(servizioId, alunno)
    },
    {
      onSuccess: (data: any) => {
        queryClient.invalidateQueries('alunniBySezioneId')
        queryClient.invalidateQueries('presenzeAlunniData')
        queryClient.invalidateQueries('countAlunniDaControllare')
        queryClient.invalidateQueries('countFruizioniDaControllare')
        cogoToast.success('Alunno creato correttamente.')
      },
      onError: () => {},
    }
  )
}

export default useCreateAlunno
